<div class="resp-container">
    <div class="close-btn-box" (click)="close()">
        <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/cross-icon-light.svg" class="close-icon" />
    </div>

    <div  [@fadeOutRightBig]="toRight" [@fadeOutLeftBig]="toLeft">
        <ng-container class="container">
            <div class="card tp-box" [@flipState]="flip"  [ngClass]="isLefZoom ? 'card-animation' :isrightZoom ? 'card-animation' :''">
              <div class="front" (click)="flipCard($event)">
                <div class="d-flex flex-row justify-content-between mem-card-header">
                    <h4 class="question-text">Question</h4>
                    <span class="mem-card-count">{{currentQuestionNumber+1}}/{{questionsData?.length}}</span>
                </div>
                <hr class="hr-rule" />
                <div class="SLV2-card-cnt-area">
                    <!-- <ng-katex-html [html]="currentQuestionData?.front.text"></ng-katex-html> -->
                    <span style="display: inline-block;">
                        <h2 class="mem-card-question" [mathMl]="currentQuestionData?.front.text"></h2>
                      </span>
            
                    <ng-container *ngIf="currentQuestionData?.front.imageURL"> <img [src]="currentQuestionData?.front.imageURL" class="mem-card-question-img" /></ng-container>
                </div>
                <span class="tab-to-see-text">Tap to see answer</span>
                <div class="change-card-btn-box d-flex flex-row justify-content-end">
                    <button class="mem-card-btn" [disabled]="currentQuestionNumber==0"><img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue.svg" class="mem-card-chng-btn" (click)="onPrevious()" /></button>
                   <button class="mem-card-btn" ><img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" /></button> 
                </div>
                <!-- <div class="change-card-btn-box d-flex flex-row justify-content-end" *ngIf="currIndex>=1">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue.svg" class="mem-card-chng-btn" (click)="onPrevious()" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" />
                </div> -->
              </div>
              <div class="back" (click)="flipCard($event)">
                <div class="d-flex flex-row justify-content-between mem-card-header-back">
                    <h4 class="question-text">Answer</h4>
                    <span class="mem-card-count">{{currentQuestionNumber+1}}/{{questionsData?.length}}</span>
                </div>
                <hr class="hr-rule-back" />
                <div class="SLV2-card-cnt-area">
                    <!-- <ng-katex-html [html]="currentQuestionData?.back.text"></ng-katex-html> -->
                    <span style="display: inline-block;">
                        <h2 class="mem-card-question" [mathMl]="currentQuestionData?.back.text"></h2>
                    </span>
                    
                    <ng-container *ngIf="currentQuestionData?.back.imageURL"> <img [src]="currentQuestionData?.front.imageURL" class="mem-card-question-img" /></ng-container>
                </div>
                <div *ngIf="!currentQuestionData?.isBookmarked" style="max-height: 50px;" (click)="bookMarkMemoryCard($event)">
                    <button class="mem-card-btn" >  <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/bookmark-outline.svg" class="bookmark-img" /></button>
                  
                </div>
                <div *ngIf="currentQuestionData?.isBookmarked" style="max-height: 50px;" (click)="bookMarkMemoryCard($event)">
                    <button class="mem-card-btn" >   <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/bookmark-filled.svg" class="bookmark-img" /></button>
                </div>
                <div class="change-card-btn-box d-flex flex-row justify-content-end" >
                    <button  class="mem-card-btn" [disabled]="currentQuestionNumber==0"><img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue.svg" class="mem-card-chng-btn" (click)="onPrevious()" /></button>
                    <button class="mem-card-btn"><img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" /></button>    
                </div>
                <!-- <div class="change-card-btn-box d-flex flex-row justify-content-end" *ngIf="currentQuestionNumber!=0">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue.svg" class="mem-card-chng-btn" (click)="onPrevious()" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" />
                </div> -->
              </div>
            </div>
        </ng-container>
    </div>

    <!-- <app-slider [isIn]="currIndex === 1" [left]="isLeftTransition(1)">
        <ng-container class="container">
            <div class="card">
              <div class="front">
                <div class="d-flex flex-row justify-content-between mem-card-header">
                    <h4 class="question-text">Question</h4>
                    <span class="mem-card-count">3/10</span>
                </div>
                <hr class="hr-rule" />
                <h2 class="mem-card-question">Large transformers, become hot and are cooled by circulating oil.</h2>
                <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/sample-question2.svg" class="mem-card-question-img" />
                <span class="tab-to-see-text" (click)="flipCard()">Tab to see answer</span>
                <div class="change-card-btn-box d-flex flex-row justify-content-end" *ngIf="currIndex<1">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue-disable.svg" class="mem-card-chng-btn" (click)="onPrevious()" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" />
                </div>
                <div class="change-card-btn-box d-flex flex-row justify-content-end" *ngIf="currIndex>=1">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue.svg" class="mem-card-chng-btn" (click)="onPrevious()" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" />
                </div>
              </div>
              <div class="back">
                <div class="d-flex flex-row justify-content-between mem-card-header-back">
                    <h4 class="question-text">Answer</h4>
                    <span class="mem-card-count">3/10</span>
                </div>
                <hr class="hr-rule-back" />
                <h2 class="mem-card-question">Large transformers, become hot and are cooled by circulating oil.</h2>
                <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/sample-question2.svg" class="mem-card-question-img" />
                <div *ngIf="!isBookmarked" style="max-height: 50px;">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/bookmark-outline.svg" class="bookmark-img" (click)="addToBookmark()" />
                </div>
                <div *ngIf="isBookmarked" style="max-height: 50px;">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/bookmark-filled.svg" class="bookmark-img" (click)="addToBookmark()" />
                </div>
                <div class="change-card-btn-box d-flex flex-row justify-content-end" *ngIf="currIndex<1">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue-disable.svg" class="mem-card-chng-btn" (click)="onPrevious()" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" />
                </div>
                <div class="change-card-btn-box d-flex flex-row justify-content-end" *ngIf="currIndex>=1">
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/left-arrow-blue.svg" class="mem-card-chng-btn" (click)="onPrevious()" />
                    <img src="selflearnv2-ui/assets/img/self-learn-v2/memory-card/right-arrow-blue.svg" class="mem-card-chng-btn" (click)="onNext()" />
                </div>
              </div>
            </div>
        </ng-container>
      </app-slider> -->
</div>
